import { render } from "./CommonMask.vue?vue&type=template&id=532e125a&scoped=true"
import script from "./CommonMask.vue?vue&type=script&lang=js"
export * from "./CommonMask.vue?vue&type=script&lang=js"

import "./CommonMask.vue?vue&type=style&index=0&id=532e125a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532e125a"]])

export default __exports__